import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Login } from '@pages/Login';
import { AdminRouter } from './adminRouter';
import { EditorRouter } from './editorRouter';
import { useEffect } from 'react';
import { RoleHomeRedirect } from '@/pages/RoleHomeRedirect';

function AppRoutes() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, [location.pathname, location.search]);

  return (
    <Routes>
      <Route path="/" element={<RoleHomeRedirect />} />
      <Route path="/login" element={<Login />} />

      {AdminRouter()}

      {EditorRouter()}

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export function AppRouter() {
  return <AppRoutes />;
}
